import colorPalette from '../color-palette';

const { primary, background } = colorPalette;

export default {
  MuiTooltip: {
    tooltip: {
      maxWidth: '400px',
      backgroundColor: background.neutral,
      color: primary.main,
      padding: '8px 16px',
      margin: '8px',
      '& ul': {
        paddingInlineStart: '10px',
        margin: '8px',
      },
    },
    tooltipPlacementBottom: {
      margin: '10px 10px 10px 20px',
    },
    arrow: {
      color: background.neutral,
      fontSize: 18,
    },
  },
};
